import type { editions as en } from '@/i18n/locales/en/editions';
import type { Translation } from '@/i18n/types';

export const editions: Translation<typeof en> = {
  fit: {
    sections: {
      home: 'Home',
      insights: 'Approfondimenti',
      programs: 'Programmi',
      content: 'Contenuti',
    },
    items: {
      overview: 'Panoramica',
      departments: 'Reparti',
      users: 'Utenti',
      vitality: 'Vitalità',
      participation: 'Partecipazione',
      pilots: 'Piloti',
      challenges: 'Sfide',
      communications: 'Comunicazione',
      documents: 'Documenti',
      reports: 'Rapporti',
      settings: 'Impostazioni',
    },
  },
  soccer: {
    sections: {
      home: 'Home',
      insights: 'Approfondimenti',
      programs: 'Programmi',
    },
    items: {
      overview: 'Panoramica',
      departments: 'Squadre',
      users: 'Giocatori',
      vitality: 'Vitalità',
      participation: 'Partecipazione',
      pilots: 'Piloti',
      challenges: 'Sfide',
    },
  },
};
